import React from 'react';
import { Switch, Route as ReactRoute } from 'react-router-dom';
import Route from './Route';
import Dashboard from '~/pages/Dashboard';
import SignIn from '~/pages/SignIn';
import ClientEditor from '~/pages/ClientPages/ClientEditor';
import FAQList from '~/pages/FAQPages/FAQList';
import FAQEditor from '~/pages/FAQPages/FAQEditor';
import Profile from '~/pages/Profile';
import FinancialApplicationList from '~/pages/FinancialApplicationPages/FinancialApplicationList';
import Inventory from '~/pages/Inventory';
import Simulation from '~/pages/VehiclePages/Simulation';
import VehicleEditor from '~/pages/VehiclePages/VehicleEditor';
import ClientList from '~/pages/ClientPages/ClientList';
import SubscriptionsList from '~/pages/SubscriptionsPages/SubscriptionsList';
import SubscriptionEditor from '~/pages/SubscriptionsPages/SubscriptionEditor';
import SubscriptionDetail from '~/pages/SubscriptionsPages/SubscriptionDetail';
import PaymentEditor from '~/pages/PaymentPages/PaymentEditor';
import ChargeEditor from '~/pages/PaymentPages/ChargeEditor';
import Reports from '~/pages/Reports';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} isAuth />
      <ReactRoute
        path="/optin"
        exact
        render={() => {
          window.location.href = 'optin.html';
        }}
      />
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/profile" component={Profile} />
      <Route path="/client" exact component={ClientList} />
      <Route path="/client/create" component={ClientEditor} />
      <Route path="/client/edit" component={ClientEditor} />
      <Route path="/financial" exact component={FinancialApplicationList} />
      <Route path="/inventory" exact component={Inventory} />
      <Route path="/reports" exact component={Reports} />
      <Route path="/vehicle/simulation" exact component={Simulation} />
      <Route path="/vehicle/create" exact component={VehicleEditor} />
      <Route path="/vehicle/edit" exact component={VehicleEditor} />
      <Route path="/faq" exact component={FAQList} />
      <Route path="/faq/edit" exact component={FAQEditor} />

      <Route
        path="/subscription/:subscriptionId/payment/:action"
        exact
        component={PaymentEditor}
      />

      <Route
        path="/subscription/:subscriptionId/charge/:action"
        exact
        component={ChargeEditor}
      />

      <Route path="/vehicle/edit" exact component={VehicleEditor} />

      <Route path="/subscription" exact component={SubscriptionsList} />
      <Route path="/subscription/edit" exact component={SubscriptionEditor} />
      <Route path="/subscription/:id" exact component={SubscriptionDetail} />
    </Switch>
  );
}
